'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getEmployeeSalaryActive(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/employeesalaries_active`
        const result = await axios.get(url, {
          ...costumHeader('Get Employee Salary Active', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getEmployeeSalary(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/employeesalaries`
        const result = await axios.get(url, {
          ...costumHeader('Get Employee Salary', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  saveEmployeeSalary(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/employeesalaries`
        const result = await axios.post(url, body, costumHeader('Save Employee Salary', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editEmployeeSalary(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/employeesalaries/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit Employee Salary', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteEmployeeSalary(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/employeesalaries/${body.id}`
        const result = await axios.delete(url, body, costumHeader('Delete Employee Salary', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }